import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12,1.25H4A2.75,2.75,0,0,0,1.25,4v8A2.76,2.76,0,0,0,4,14.75h8A2.75,2.75,0,0,0,14.75,12V4A2.75,2.75,0,0,0,12,1.25ZM2.75,12V4A1.25,1.25,0,0,1,4,2.75H7.25v10.5H4A1.26,1.26,0,0,1,2.75,12Zm10.5,0A1.26,1.26,0,0,1,12,13.25H8.75V2.75H12A1.25,1.25,0,0,1,13.25,4Z';
const draw24px =
  'M19,2.29H5A2.75,2.75,0,0,0,2.28,5V19A2.75,2.75,0,0,0,5,21.72H19A2.75,2.75,0,0,0,21.72,19V5A2.75,2.75,0,0,0,19,2.29ZM3.78,19V5A1.25,1.25,0,0,1,5,3.79h6.22V20.22H5A1.25,1.25,0,0,1,3.78,19Zm16.44,0A1.25,1.25,0,0,1,19,20.22H12.75V3.79H19A1.25,1.25,0,0,1,20.22,5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const QuadrantTwoIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'quadrantTwo'),
) as IconWithRender;

QuadrantTwoIcon.displayName = 'QuadrantTwoIcon';
QuadrantTwoIcon.propTypes = Icon.propTypes;
QuadrantTwoIcon.renderIcon = (props) => <QuadrantTwoIcon {...props} />;
export default QuadrantTwoIcon;
